import React from 'react';

const ProductIcon = function ProductIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_8575_4435" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8575_4435)">
        <path d="M20.6174 6.75312L12.6231 3.95082C12.5011 3.90799 12.3676 3.90799 12.2456 3.95082L4.25198 6.75312C4.02286 6.83306 3.86938 7.04934 3.86938 7.29202V16.9152C3.86938 17.1578 4.02285 17.3734 4.25198 17.454L12.2463 20.2563C12.3077 20.2778 12.3712 20.2885 12.4347 20.2885C12.4982 20.2885 12.5625 20.2778 12.6231 20.2563L20.6174 17.454C20.8466 17.3741 21 17.1578 21 16.9152V7.29202C21 7.04934 20.8466 6.83378 20.6174 6.75312ZM12.4347 5.09502L18.7032 7.29195L16.4319 8.08781L10.1635 5.89089L12.4347 5.09502ZM12.4347 9.48905L6.1663 7.29213L8.43759 6.49626L14.706 8.69319L12.4347 9.48905ZM5.01146 8.09719L11.873 10.5026C11.868 10.5326 11.8638 10.5626 11.8638 10.594V18.9122L5.0115 16.5103L5.01146 8.09719ZM13.0058 18.9124V10.5942C13.0058 10.5627 13.0015 10.5328 12.9965 10.5028L19.8581 8.09737V16.5099L13.0058 18.9119L13.0058 18.9124Z" fill="#424B50" />
      </g>
    </svg>
  );
};

export default ProductIcon;
